import {Observable} from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {ApiVisa, BaseApiTemplateService, Core2Config, Pagination, PagingResponseModel} from "../../../shared";
import { QrCodeScanReportResponseDto } from '../../../../data-transfer-objects/alg/cc/qr-code-scan-report-response-dto.model';

@Injectable({ providedIn: 'root' })
export class QrCodeScanReportService extends BaseApiTemplateService<QrCodeScanReportResponseDto> {
  constructor(theHttp: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + 'reports/qr-code-report';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + 'reports/qr-code-report';
    this.httpClient = theHttp;
    }


    getQrCodeScanReport(pagination: Pagination, visa: ApiVisa): Observable<PagingResponseModel<QrCodeScanReportResponseDto>> {
      if (this.endpoint_path && visa.api_domain_url) {
        this.apiUrl = visa.api_domain_url + this.endpoint_path;
      }
      const UrlByCriteria = this.apiUrl + '?' + pagination.getQueryKeyValues();
      return this.httpClient.get<PagingResponseModel<QrCodeScanReportResponseDto>>(
        UrlByCriteria,
        this.getHttpHeader(visa)
      );
    }
    
}
